document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector('body.page-template-default')) {
        return;
    }

    const sections = document.querySelectorAll('[data-section-title]');
    
    if (!sections.length) {
        return;
    }

    const nav = document.createElement('nav');
    nav.id = 'scrolling-nav';
    nav.className = 'scrolling-nav';

    const title = document.createElement('div');
    const isEnglish = document.documentElement.lang === 'en-US' || document.documentElement.lang === 'EN';
    title.textContent = isEnglish ? "Content" : "Innhold";
    title.className = "nav-title";

    const navList = document.createElement('ul');
    
    let hasAnyTitle = false;
    
    sections.forEach((section, index) => {
        if (!section.id) {
            section.id = `section-${index + 1}`;
        }

        const sectionName = section.getAttribute('data-section-title');
        if (sectionName) {
            hasAnyTitle = true;
            
            const li = document.createElement('li');
            const link = document.createElement('a');
            const linksSpan = document.createElement('span');
            link.href = `#${section.id}`;
            link.textContent = sectionName;

            link.addEventListener('click', (e) => {
                e.preventDefault();
                section.scrollIntoView({ behavior: 'smooth' });
            });

            li.appendChild(linksSpan);
            li.appendChild(link);
            navList.appendChild(li);
        }
    });

    if (!hasAnyTitle) {
        nav.classList.add('hide');
        title.classList.add('hide');
    }

    nav.appendChild(title);
    nav.appendChild(navList);

    const firstSection = sections[0];
    if (firstSection && firstSection.parentNode) {
        firstSection.parentNode.insertBefore(nav, firstSection);
    }
    
    const lastSection = sections[sections.length - 1];
    let lastSectionTop = 0;
    
    function updateLastSectionPosition() {
        if (lastSection) {
            const rect = lastSection.getBoundingClientRect();
            lastSectionTop = window.scrollY + rect.top; 
        }
    }
    
   
    updateLastSectionPosition();
    
    
    window.addEventListener('resize', updateLastSectionPosition);

    
    window.addEventListener('scroll', () => {
        const scrollY = window.scrollY;
        
        
        if (scrollY >= lastSectionTop) {
            nav.classList.add('stop-sticky');
            
        } else {
            nav.classList.remove('stop-sticky');
        }
        
       
        let visibleSections = [];
        sections.forEach((section) => {
            const rect = section.getBoundingClientRect();
            const sectionName = section.getAttribute('data-section-title');
            
            // Only track sections with titles
            if (sectionName && rect.top <= 100 && rect.bottom >= 100) {
                visibleSections.push(section);
            }
        });
        
        // Mark the first visible section as active
        if (visibleSections.length > 0) {
            const activeSection = visibleSections[0];
            const activeSectionId = activeSection.id;
            
            navList.querySelectorAll('li').forEach(item => {
                const link = item.querySelector('a');
                if (link && link.getAttribute('href') === `#${activeSectionId}`) {
                    item.classList.add('active');
                } else {
                    item.classList.remove('active');
                }
            });
        }
    });
});